// Clones the fallback subscribe form into every <div data-subscribe-form>
// placeholder the editor dropped into the page body. When at least one
// inline marker is present, the automatic block at the bottom of the
// template is hidden so the CTA isn't duplicated.

export default function subscribeInjector() {
  const placeholders = document.querySelectorAll('[data-subscribe-form]');
  if (!placeholders.length) return;

  const fallback = document.querySelector('[data-auto-subscribe-form]');
  if (!fallback) return;

  const form = fallback.querySelector('form.th-newsletter-form');
  if (!form) return;

  placeholders.forEach((el) => {
    el.classList.add('th-cta-newsletter');
    el.appendChild(form.cloneNode(true));
  });

  fallback.hidden = true;
}
